import { ActionTypes } from 'modules/experiments/ducks/actionTypes';
import {
  AnalyticsI18nPayload,
  BasePageExperimentData,
  OverviewTabExperimentData,
  PerformanceTabExperimentData,
  PerformanceTabQuery,
} from 'modules/experiments/types';
import { AnalyticsMetric } from 'modules/graphql';

export const updateExperimentName = (name: string) => ({
  type: ActionTypes.UPDATE_EXPERIMENT_NAME,
  name,
});

/** New AC */
export const analyticsPageLoaded = (experimentId: number) => ({
  type: ActionTypes.ANALYTICS_PAGE_LOADED,
  experimentId,
});

export const analyticsPageOverviewTabLoaded = (experimentId: number) => ({
  type: ActionTypes.ANALYTICS_PAGE_OVERVIEW_TAB_LOADED,
  experimentId,
});

export const analyticsPagePerformanceTabLoaded = (queryData: PerformanceTabQuery) => ({
  type: ActionTypes.ANALYTICS_PAGE_PERFORMANCE_TAB_LOADED,
  queryData,
});

export const i18nTranslations = (payload: AnalyticsI18nPayload) => ({
  type: ActionTypes.SET_I18N_TRANSLATIONS,
  payload,
});

export const analyticsMetricsList = (payload: AnalyticsMetric[]) => ({
  type: ActionTypes.SET_ANALYTICS_METRICS,
  payload,
});

export const analyticsBasePageData = (payload: BasePageExperimentData) => ({
  type: ActionTypes.SET_ANALYTICS_BASE_PAGE_DATA,
  payload,
});

export const analyticsOverviewTabData = (payload: OverviewTabExperimentData) => ({
  type: ActionTypes.SET_ANALYTICS_OVERVIEW_TAB_DATA,
  payload,
});

export const analyticsPerformanceTabData = (payload: PerformanceTabExperimentData) => ({
  type: ActionTypes.SET_ANALYTICS_PERFORMANCE_TAB_DATA,
  payload,
});

export const analyticsBasePageDataError = () => ({
  type: ActionTypes.ANALYTICS_BASE_PAGE_DATA_ERROR,
});

export const analyticsOverviewTabDataError = () => ({
  type: ActionTypes.ANALYTICS_OVERVIEW_TAB_DATA_ERROR,
});

export const analyticsPerformanceDataError = () => ({
  type: ActionTypes.ANALYTICS_PERFORMANCE_TAB_DATA_ERROR,
});

export const analyticsOverviewTabDataLoaded = () => ({
  type: ActionTypes.ANALYTICS_OVERVIEW_TAB_DATA_LOADED,
});

export const analyticsPerformanceDataLoaded = () => ({
  type: ActionTypes.ANALYTICS_PERFORMANCE_TAB_DATA_LOADED,
});

export const analyticsReloadOverviewTabData = (experimentId: number) => ({
  type: ActionTypes.ANALYTICS_RELOAD_OVERVIEW_TAB_DATA,
  experimentId,
});

export const analyticsReloadPerformanceTabData = (queryData: PerformanceTabQuery) => ({
  type: ActionTypes.ANALYTICS_RELOAD_PERFORMANCE_TAB_DATA,
  queryData,
});
